var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 card" }, [
    _c(
      "div",
      {
        staticClass:
          "card-header bg-secondary-3 d-flex justify-content-between align-items-center"
      },
      [
        _c("div", [
          _vm._v(" Prueba/Muestra Módulo: "),
          _c("b", [
            _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area.name)) + " ")
          ])
        ]),
        _c("div", [
          !_vm.isReadOnly
            ? _c("i", {
                staticClass: "far fa-times-circle text-danger pointer",
                on: { click: _vm.remove }
              })
            : _vm._e()
        ])
      ]
    ),
    _c("div", { staticClass: "card-body bg-secondary-3" }, [
      _c("div", [
        _c("div", { staticClass: "font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("empty")(_vm.value.area.letter)))
        ]),
        _c("div", { staticClass: "data-name" }, [
          _vm._v(_vm._s(_vm._f("empty")(_vm.value.area.description)))
        ])
      ]),
      _c(
        "div",
        { staticClass: "my-3" },
        [
          _c("label", { staticClass: "data-name" }, [_vm._v("Resultados:")]),
          _vm.isReadOnly
            ? _c("p", [_vm._v(_vm._s(_vm._f("empty")(_vm.model.comment)))])
            : _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            "count-classes": [
                              "d-block",
                              "small-counter",
                              "text-right"
                            ],
                            "custom-error-msg": "El campo es requerido.",
                            error: errors[0],
                            maxlength: 5000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.comment,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "comment", $$v)
                            },
                            expression: "model.comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "my-3" },
        [
          _c("label", { staticClass: "data-name" }, [
            _vm._v("Interpretación:")
          ]),
          _vm.isReadOnly
            ? _c("p", [
                _vm._v(_vm._s(_vm._f("empty")(_vm.model.interpretation)))
              ])
            : _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            "count-classes": [
                              "d-block",
                              "small-counter",
                              "text-right"
                            ],
                            "custom-error-msg": "El campo es requerido.",
                            error: errors[0],
                            maxlength: 5000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.model.interpretation,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "interpretation", $$v)
                            },
                            expression: "model.interpretation"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }